import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";

export class EmployeeOnboardingAcceptanceDto extends BaseEntityDto {
  processId: string;
  signatureRequirementId: string;
  documentVersionId?: string | null;
  consentText: string;
  ipAddress: string;
  userAgent: string;
  contentHash: string;

  @Transform(({ value }) => parseApiDate(value))
  acceptedAt: Date;
}
